import Vue from 'vue';
import VueRouter from 'vue-router';
import Router from 'vue-router';

Vue.use(Router);

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch(err => err);
};
export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/dashboard',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/UpdatePwd',
                    component: () => import(/* webpackChunkName: "UpdatePwd" */ '../components/page/UpdatePwd.vue'),
                    meta: { title: '修改密码' }
                },
                {
                    path: '/icon',
                    component: () => import(/* webpackChunkName: "icon" */ '../components/page/Icon.vue'),
                    meta: { title: '自定义图标' }
                },
                {
                    path: '/tabs',
                    component: () => import(/* webpackChunkName: "tabs" */ '../components/page/Tabs.vue'),
                    meta: { title: 'tab选项卡' }
                },
                {
                    // 文件上传
                    path: '/upload',
                    component: () => import(/* webpackChunkName: "upload" */ '../components/page/projects/Upload.vue'),
                    meta: { title: '项目上传' }
                },
                {
                    // 文件信息
                    path: '/ProjectInfo',
                    component: () => import(/* webpackChunkName: "ProjectInfo" */ '../components/page/projects/ProjectInfo.vue'),
                    meta: { title: '项目列表' }
                },
                {
                    // 项目文件
                    path: '/projectFile',
                    component: () => import(/* webpackChunkName: "projectFile" */ '../components/page/projects/ProjectFile.vue'),
                    meta: { title: '项目文件' }
                },
                {
                    // 项目信息
                    path: '/ProjectPath',
                    component: () => import(/* webpackChunkName: "ProjectPath" */ '../components/page/projects/ProjectPath'),
                    meta: { title: '项目信息' }
                },
                {
                    // 广告
                    path: '/advert',
                    component: () => import('../components/page/projects/advert/index.vue'),
                    meta: { title: '广告信息' }
                },
                {
                    // 广告组
                    path: '/advertGroup',
                    component: () => import('../components/page/projects/advertGroup/index.vue'),
                    meta: { title: '广告组' }
                },
                {
                    // 设备信息
                    path: '/deviceInfo',
                    component: () => import(/* webpackChunkName: "deviceInfo" */ '../components/page/devices/DeviceInfo.vue'),
                    meta: { title: '设备信息' }
                },
                {
                    // 实名 项目信息
                    path: '/AntiProjectData',
                    component: () => import(/* webpackChunkName: "AntiProjectData" */ '../components/page/antiaddiction/AntiProjectData.vue'),
                    meta: { title: 'ProjectData' }
                },
                {
                    path: '/projectGroup',
                    component: () => import('../components/page/projects/projectGroup/index.vue'),
                    meta: { title: '项目组' }
                },
                {
                    // 实名 玩家名单可修改出生日期
                    path: '/Players',
                    component: () => import(/* webpackChunkName: "Players" */ '../components/page/antiaddiction/Players.vue'),
                    meta: { title: '玩家信息' }
                },
                {
                    // 实名 实名认证测试
                    path: '/AntiaddictionTest',
                    component: () => import(/* webpackChunkName: "AntiaddictionTest" */ '../components/page/antiaddiction/AntiaddictionTest.vue'),
                    meta: { title: '实名制测试' }
                },
                {
                    // alipay支付
                    path: '/AliPay',
                    component: () => import(/* webpackChunkName: "AliPay" */ '../components/page/pay/alipay/AliPay.vue'),
                    meta: { title: 'AliPay' }
                },
                {
                    // 阿里支付操作页
                    path: '/AlipayOperation',
                    component: () => import(/* webpackChunkName: "AlipayOperation" */ '../components/page/pay/alipay/AlipayOperation.vue'),
                    meta: { title: 'AlipayOperation' }
                },
                {
                    // wx支付
                    path: '/WxPay',
                    component: () => import(/* webpackChunkName: "WxPay" */ '../components/page/pay/WxPay.vue'),
                    meta: { title: 'WxPay' }
                },

                {
                    // 商品
                    path: '/Produce',
                    component: () => import(/* webpackChunkName: "WxPay" */ '../components/page/produce/Produce.vue'),
                    meta: { title: 'Produce' }
                },

                {
                    // 任务
                    path: '/taskTiming',
                    component: () => import( '../components/page/timing/TaskTiming.vue'),
                    meta: { title: '定时任务' }
                },
                {
                    // 任务
                    path: '/taskTimingModify',
                    component: () => import( '../components/page/timing/TaskTimingModify.vue'),
                    meta: { title: '添加/更新任务' }
                },

                {
                    // GM工具 Game 总控制
                    path: '/Gameconsole',
                    component: () => import(/* webpackChunkName: "Gameconsole" */ '../components/page/gamemanager/Gameconsole.vue'),
                    meta: { title: 'GM 工具' }
                },
                {
                    // GM工具 新增公告
                    path: '/Notice',
                    component: () => import(/* webpackChunkName: "Notice" */ '../components/page/gamemanager/Notice.vue'),
                    meta: { title: '公告' }
                },
                {
                    // GM工具 新增邮件
                    path: '/Email',
                    name: '/Email',
                    component: () => import(/* webpackChunkName: "Email" */ '../components/page/gamemanager/Email.vue'),
                    meta: { title: '邮件' }
                },


                {
                    // 角色管理
                    path: '/roleManage',
                    component: () => import(/* webpackChunkName: "RoleManage" */ '../components/page/role/RoleManage.vue'),
                    meta: { title: '角色管理' }
                },
                // 角色信息管理
                {
                    path: '/roleInfo',
                    component: () => import('../components/page/system/RoleInfo.vue'),
                    meta: { title: '角色信息' }
                },
                {
                    // 权限页面
                    path: '/role',
                    component: () => import(/* webpackChunkName: "Role" */ '../components/page/system/Role.vue'),
                    meta: { title: '权限管理' }
                },
                {
                    // 权限部分
                    path: '/permission',
                    component: () => import('../components/page/system/permission/index.vue'),
                    meta: { title: '权限' }
                },
                {
                    path: '/userGroup',
                    meta: { title: '用户权限' },
                    component: () => import('../components/page/system/systemUser/Index.vue')
                },
                {
                    // 白名单
                    path: '/whiteUrl',
                    component: () => import('../components/page/system/whiteUrl/index.vue'),
                    meta: { title: '白名单' }
                },
                {
                    // 权限页面
                    path: '/position',
                    component: () => import(/* webpackChunkName: "Position" */ '../components/page/system/Position.vue'),
                    meta: { title: '职能管理' }
                },


                {
                    // 系统日志
                    path: '/systemLog',
                    component: () => import(/* webpackChunkName: "systemLog" */ '../components/page/log/SystemLog.vue'),
                    meta: { title: '系统日志' }
                },

                {
                    // 客服人员
                    path: '/customer',
                    component: () => import(/* webpackChunkName: "systemLog" */ '../components/page/customer/Customer.vue'),
                    meta: { title: '系统日志' }
                },


                {
                    // Svn管理
                    path: '/svnManage',
                    component: () => import(/* webpackChunkName: "SvnManage" */ '../components/page/svn/SvnManage.vue'),
                    meta: { title: 'Svn管理' }
                },
                {
                    // Svn 用户新增
                    path: '/svnInsert',
                    component: () => import(/* webpackChunkName: "svnInsert" */ '../components/page/svn/SvnInsert.vue'),
                    meta: { title: 'Svn用户创建' }
                },
                {
                    // Svn 用户编辑  传入 ID
                    path: '/svnEdit',
                    name: '/SvnEdit',
                    component: () => import(/* webpackChunkName: "svnEdit" */ '../components/page/svn/SvnEdit.vue'),
                    meta: { title: 'Svn用户编辑' }
                },
                {
                    // Svn 用户个人信息
                    path: '/svnEditPersonal',
                    name: '/svnEditPersonal',
                    component: () => import(/* webpackChunkName: "svnEdit" */ '../components/page/svn/SvnEditPersonal.vue'),
                    meta: { title: 'Svn用户编辑' }
                },
                {
                    // Svn 服务状态
                    path: '/svnStatus',
                    component: () => import(/* webpackChunkName: "SvnStatus" */ '../components/page/svn/SvnStatus.vue'),
                    meta: { title: 'Svn服务状态' }
                },
                {
                    // Svn 访问规则
                    path: '/svnAuthorization',
                    component: () => import(/* webpackChunkName: "svnAuthorization" */ '../components/page/svn/SvnAuthorization.vue'),
                    meta: { title: 'Svn访问规则' }
                },
                {
                    // Svn 备份信息
                    path: '/authorizationInfo',
                    component: () => import(/* webpackChunkName: "authorizationInfo" */ '../components/page/svn/AuthorizationInfo.vue'),
                    meta: { title: 'Svn备份信息' }
                },
                {
                    // Svn 登录
                    path: '/svnLogin',
                    component: () => import(/* webpackChunkName: "svnLogin" */ '../components/page/svn/SvnExit.vue'),
                    meta: { title: 'Svn登录' }
                },
                {
                    // Svn 登出
                    path: '/svnExit',
                    component: () => import(/* webpackChunkName: "svnExit" */ '../components/page/svn/SvnExit.vue'),
                    meta: { title: 'Svn登出' }
                },


                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/error/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/error/403.vue'),
                    meta: { title: '403' }
                },

                // QQ机器人
                {
                    path: 'qqBot',
                    component: () => import('../components/page/alterWarning/QQBotInfo.vue'),
                    meta: { title: 'QQ机器人' }
                },
                // Api接口信息
                {
                    path: 'apiInfo',
                    component: () => import('../components/page/alterWarning/ApiInfo.vue'),
                    meta: { title: 'Api接口信息' }
                },
                // 用户预警账户配置
                {
                    path: 'userNoticeConfig',
                    component: () => import('../components/page/alterWarning/UserNoticeConfig.vue'),
                    meta: { title: '用户预警账户配置' }
                },
                // 项目版本信息
                {
                    path: 'projectVersion',
                    component: () => import('../components/page/projects/projectVersion/index.vue'),
                    meta: { title: '项目版本信息' }
                },
                {
                    path: 'projectServiceStatus',
                    component: () => import('../components/page/projects/ProjectServiceStatus.vue'),
                    meta: { title: '项目服务器状态' }
                },
                {
                    path: 'resourceDownloadAuth',
                    component: () => import('../components/page/projects/ResourceDownloadAuth.vue'),
                    meta: { title: '资源下载认证' }
                },
                {
                    path: 'projectSetting',
                    component: () => import('../components/page/antiaddiction/ProjectSetting.vue'),
                    meta: {title: '项目防沉迷设置'}
                },
                {
                    path: 'antiAddictionSetting',
                    component: () => import('../components/page/antiaddiction/AntiAddictionSetting.vue'),
                    meta: {title: '防沉迷设置'}
                },
                {
                    path: 'gameDetail',
                    component: () => import('../components/page/projects/gameDetail/index.vue'),
                    meta: {title: '游戏详情'}
                },
                {
                    path: 'newProjectInfo',
                    component: () => import('../components/page/projects/ProjectInfo/index.vue'),
                    meta: { title: '新版项目信息' }
                },
                {
                    path: 'projectCustomSetting',
                    component: () => import('../components/page/projects/ProjectCustomSetting.vue'),
                    meta: { title: '项目自定义配置' }
                },
                {
                    path: 'fileManager',
                    component: () => import('../components/page/file/FileManager/index.vue'),
                    meta: { title: '文件管理' }
                },
                {
                    path: 'exportTask',
                    component: () => import('../components/page/file/ExportTask/index.vue'),
                    meta: { title: '导出数据' }
                },
                {
                    path: 'generatePlayer',
                    component: () => import('@/components/page/antiaddiction/generatePlayer/index.vue'),
                    meta: { title: '生成玩家账号' }
                },
                {
                    path: 'trackEvent',
                    component: () => import('@view/track/eventManage/TrackEvent.vue'),
                    meta: { title: '埋点事件', keepAlive: false }
                },
                {
                    path: '/analyseReportManage',
                    component: () => import('@view/track/analyseReportManager/index.vue'),
                    meta: {title: '埋点分析报表管理'}
                },
                {
                    path: '/trackData',
                    component: () => import('@view/track/trackData/index.vue'),
                    meta: {title: '埋点事件数据'}
                },
                {
                    path: '/trackAnalyse',
                    component: () => import('@view/track/analyse/TrackAnalyse.vue'),
                    meta: {title: '埋点报表看板'},
                    children: [
                        {
                            path: 'newUser/:projectAppId?',
                            meta:{title: '新增用户分析', keepAlive: false},
                            component: () => import('@view/track/analyse/component/NewUser.vue')
                        },
                        {
                            meta: {title: '活跃用户分析', keepAlive: false},
                            path: 'activeUser/:projectAppId?',
                            component: () => import('@view/track/analyse/component/ActiveUser.vue')
                        },
                        {
                            meta: {title: '留存用户分析', keepAlive: false},
                            path: 'retentionUser/:projectAppId?',
                            component: () => import('@view/track/analyse/component/RetentionUser.vue')
                        },
                        {
                            meta: {title: '概述', keepAlive: false},
                            path: 'summary/:projectAppId?',
                            component: () => import('@view/track/analyse/component/TrackSummary.vue')
                        },
                        {
                            meta: {title: '事件概述', keepAlive: false},
                            path: 'eventSummary/:projectAppId?/:eventId?',
                            component: () => import('@view/track/analyse/component/EventSummary.vue')
                        },
                        {
                            meta: { title: '事件分析', keepAlive: false },
                            path: 'eventAnalyse/:projectAppId?/:eventId?',
                            component: () => import('@view/track/analyse/component/EventAnalyse.vue')
                        },
                        {
                            meta: { title: '事件分析', keepAlive: false },
                            path: 'singleEventAnalyse/:projectAppId?/:eventId?/:reportId?',
                            component: () => import('@view/track/analyse/component/SingleEventAnalyse.vue')
                        }

                    ]
                },

                {
                    path: '/storage-application',
                    component: () => import('@view/storage/index/index.vue'),
                    meta: { title: '应用管理' }
                },
                {
                    path: '/storage-info/:appId?',
                    component: () => import('@view/storage/manage/index.vue'),
                    meta: { title: '数据存储' },
                    children: [
                        {
                            path: 'data/:className',
                            meta: { title: '数据存储', keepAlive: false },
                            component: () => import('@view/storage/manage/component/StorageData.vue')
                        },
                        {
                            meta: { title: '存储安全', keepAlive: false },
                            path: 'security',
                            component: () => import('@view/storage/manage/component/StorageSecurity.vue')
                        },
                        {
                            meta: { title: '存储设置', keepAlive: false },
                            path: 'settings',
                            component: () => import('@view/storage/manage/component/Settings.vue')
                        },
                        {
                            meta: { title: '存储日志', keepAlive: false },
                            path: 'requestDetails',
                            component: () => import('@view/storage/manage/component/RequestDetails.vue')
                        }

                    ]
                },
                {
                    path: '/giftCode',
                    component: () => import('@view/operation/giftCode/GiftCodeManage.vue'),
                    meta: { title: '礼包码' }
                },
                {
                    path: '/redemptionRecord',
                    component: () => import('@view/operation/giftCode/RedemptionRecord.vue'),
                    meta: { title: '兑换记录' }
                },

                {
                    path: '/archiveList',
                    component: () => import('@view/operation/archive/ArchiveManage.vue'),
                    meta: { title: '项目Bug日志列表' }
                },
                {
                    path: '/archiveControl',
                    component: () => import('@view/operation/archive/ArchiveUploadControl.vue'),
                    meta: { title: '项目Bug上传控制' }
                },
                {
                    path: '/im',
                    component: () => import('@view/im/Controller.vue'),
                    meta: { title: 'Im系统' },
                    children: [
                        {
                            path: 'chat/:projectName?',
                            meta: { title: '聊天', keepAlive: false },
                            component: () => import('@view/im/component/ImChat.vue')
                        },
                        {
                            meta: { title: '消息列表', keepAlive: false },
                            path: 'messages/:projectName?',
                            component: () => import('@view/im/component/MessageList.vue')
                        },
                        {
                            meta: { title: '消息模板列表', keepAlive: false },
                            path: 'msgTemplates/:projectName?',
                            component: () => import('@view/im/component/MessageTemplate.vue')
                        },
                        {
                            meta: { title: '概述', keepAlive: false },
                            path: 'summary/:projectName?',
                            component: () => import('@view/im/component/Summary.vue')
                        },
                        {
                            meta: { title: '好友关系列表', keepAlive: false },
                            path: 'friends/:projectName?',
                            component: () => import('@view/im/component/FriendRelationship.vue')
                        },
                        {
                            meta: { title: '好友请求列表', keepAlive: false },
                            path: 'friendRequests/:projectName?',
                            component: () => import('@view/im/component/FriendRequest.vue')
                        },
                        {
                            meta: { title: '频道列表', keepAlive: false },
                            path: 'channels/:projectName?',
                            component: () => import('@view/im/component/ChannelList.vue')
                        },
                        {
                            meta: { title: '频道成员列表', keepAlive: false },
                            path: 'channelMembers/:projectName?',
                            component: () => import('@view/im/component/ChannelMember.vue')
                        },
                        {
                            meta: { title: '消息触发列表', keepAlive: false },
                            path: 'msgTriggers/:projectName?',
                            component: () => import('@view/im/component/MsgTrigger.vue')
                        }

                    ]
                },
                {
                    path: 'appMd5',
                    component: () => import('../components/page/projects/AppMd5.vue'),
                    meta: { title: '应用md5' }
                },

                {
                    path: '/componentTest',
                    component: () => import('@view/test/Test.vue'),
                    meta: { title: '测试' }
                },
                {
                    path: '/payOrder',
                    component: () => import('@view/pay/PayOrder.vue'),
                    meta: { title: '订单' }
                },
                {
                    path: '/payEvent',
                    component: () => import('@view/pay/PayEvent.vue'),
                    meta: { title: '支付事件' }
                }
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: 'cottongamestore' }
        },
        {
            path: '/register',
            component: () => import(/* webpackChunkName: "register" */ '../components/page/Register.vue'),
            meta: { title: '注册页面' }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]

});
